export default {
  basic: () => import("/app/src/layouts/basic.vue").then(m => m.default || m),
  default: () => import("/app/src/layouts/default.vue").then(m => m.default || m),
  docs: () => import("/app/src/layouts/docs.vue").then(m => m.default || m)
}